module.exports = __webpack_public_path__ + "static/assets/d338cdaf0578e0bcdf0d68247ef8a86a.svg";